<template>
  <section>
    <div class="col-sm-12 col-md-12 form-group pt-3 mt-2">
      <div class="col-sm-12 col-md-12 form-group text-left pb-0 mb-0">
        <p
          class="text-center"
          style="font-size: 1rem; line-height: 24px"
          :style="template.secondaryTheme ? 'color:white;' : ''"
        >
          {{ $t('recover.title') }}
        </p>
      </div>

      <!-- Error -->
      <div v-if="errors.length" class="col form-group">
        <div class="mb-1 mt-2 p-2 c-errors">
          <p class="fontMenor mb-2" :style="template.secondaryTheme ? 'color: white;' : ''">
            <strong>{{ errors[0].title }}</strong>

            <br />

            {{ errors[0].msg }}
          </p>
        </div>
      </div>

      <p
        class="my-5 col fontMenor text-center"
        style="word-break: break-word"
        :style="template.secondaryTheme ? 'color:white;' : ''"
      >
        <small>{{ instructionText }}</small>
      </p>

      <div class="col form-group mt-5 mb-4">
        <input
          v-if="config.loginType == 4"
          id="email"
          v-model="userLogin"
          class="w-100"
          :class="template.secondaryTheme ? 'secondary-input-theme' : 'c-input'"
          :placeholder="$t('login.email')"
          :style="{ borderColor: template.inputBorderColor }"
          type="email"
          @keyup="errors = []"
        />

        <input
          v-else
          id="email"
          v-model="userLogin"
          class="w-100"
          :class="template.secondaryTheme ? 'secondary-input-theme' : 'c-input'"
          :placeholder="$t('login.cpf')"
          :style="{ borderColor: template.inputBorderColor }"
          type="email"
          @keyup="errors = []"
        />
      </div>

      <!-- Buttons -->
      <div class="col-sm-12 col-md-12 form-group mt-2 pt-3">
        <button
          class="btn btn-block shadow-sm btnStock btn"
          :style="primaryBtnStyle"
          type="submit"
          @click="recuperaEmail"
        >
          {{ $t('recover.submit') }}
        </button>

        <button
          class="btn btn-block shadow-sm btnStock btn mt-3"
          :style="template.secondaryTheme ? secondaryBtnStyleTheme : secondaryBtnStyle"
          @click="$router.push(goToHomePage)"
        >
          <i class="fa fa-caret-left" />

          {{ $t('recover.back') }}
        </button>
      </div>
    </div>
  </section>
</template>

<script>
/* State */
import { mapState, mapGetters } from 'vuex'

/* Services */
import { loginFB } from '../../services/ServFB.js'

import { getSSORedirectUrl } from '@/helpers/ssoHelper'

const lFB = new loginFB()

export default {
  name: 'Inicio',
  data: () => ({
    errors: [],
    userLogin: '',
  }),
  computed: {
    ...mapGetters(['primaryBtnStyle', 'secondaryBtnStyle', 'secondaryBtnStyleTheme']),
    ...mapState(['config', 'template', 'subdomain', 'sso']),
    goToHomePage() {
      return getSSORedirectUrl(this.config)
    },
    instructionText() {
      const isEmail = Number(this.config.loginType) === 4
      if (this.template.secondaryTheme) {
        return isEmail
          ? this.$t('recover.instructionEmailPassword')
          : this.$t('recover.instructionCpfPassword')
      }
      return isEmail
        ? this.$t('recover.instructionEmail')
        : this.$t('recover.instructionCpf')
    },
  },
  mounted() {
    document.getElementById('email').focus()
  },
  methods: {
    recuperaEmail() {
      if (this.userLogin) {
        this.postEmail()
      } else {
        this.errors.push({
          type: 'email',
          title: this.$t('recover.incompleteData'),
          msg: this.$t('recover.fillField'),
        })
      }
    },
    postEmail() {
      const data = {
        ownerID: parseInt(this.config.ownerId),
        sysId: parseInt(this.config.systemID),
        login: this.userLogin,
      }

      lFB
        .recoverPwd(data)
        .then(res => {
          this.$store.commit('setRecoveryDestination', res)
          this.$emit('component', 'msg-email')
        })
        .catch(err => {
          this.errors.push({
            type: 'post',
            title: this.$t('recover.submitError'),
            msg: `${err}`,
          })
        })
    },
  },
}
</script>
